import { servicios } from '../properties';
import appTimer from '../app-timer';

export const guardarContrasena = (sParam) => {
    return fetch(servicios.guardarContrasena, {
        method: 'post',
        body: JSON.stringify({
            contrasena: sParam.contrasena,
            confirmacion: sParam.confirmacion
        })
    });
}


// WEBPACK FOOTER //
// ./src/modificar/servicios.act.js